import React from "react";
import WorkingPartDetail from "../../../components/user/workingPartSnap/workingPartDetail";
import Layout from "../../../components/layouts/verticalLayout";
import { useParams } from "react-router-dom";

const WorkingPartDetailPage = () => {
  let { uuid } = useParams();
  return <Layout body={<WorkingPartDetail uuid={uuid} />} />;
};

WorkingPartDetailPage.propTypes = {};

export default WorkingPartDetailPage;
